import { trackUserAnalytics } from '../useAnalyticsTrack';
import { MO_TRACK_EVENTS_ACCOUNT } from '../../mo-track-events';
import { LOGIN_METHODS, LOGIN_ORIGIN } from '../../../utils/constants';
import { getLoginErrorReason } from '../../../routes/Auth/utils';

export const emailLoginAttemptAnalyticsTrack = () => {
  trackUserAnalytics({
    eventType: MO_TRACK_EVENTS_ACCOUNT.SUBMIT_LOGIN_FORM,
    eventProperties: {
      loginMethod: LOGIN_METHODS.EMAIL,
      app: LOGIN_ORIGIN,
    },
    avoidBackendTracking: true,
  });
};

export const emailLoginSuccessAnalyticsTrack = () => {
  trackUserAnalytics({
    eventType: MO_TRACK_EVENTS_ACCOUNT.LOGIN_SUCCESS,
    eventProperties: {
      loginMethod: LOGIN_METHODS.EMAIL,
    },
    avoidBackendTracking: true,
  });
};

export const emailLoginFailedAnalyticsTrack = (err) => {
  trackUserAnalytics({
    eventType: MO_TRACK_EVENTS_ACCOUNT.LOGIN_FAILED,
    eventProperties: {
      loginMethod: LOGIN_METHODS.EMAIL,
      reason: getLoginErrorReason(err),
    },
    avoidBackendTracking: true,
  });
};
